import { useState, useEffect } from 'react';

/**
 * Custom hook to enforce a minimum loading time for a loading indicator.
 * This ensures the loading state remains active for at least the specified
 * minimum duration, which helps prevent quick flashes of loading indicators.
 */

export const useMinimumLoadingTime = (
	isLoading: boolean,
	minimumTime = 300
) => {
	const [loading, setLoading] = useState(true);
	const [initialLoadTime] = useState(Date.now());

	useEffect(() => {
		if (!isLoading) {
			const elapsedTime = Date.now() - initialLoadTime;
			const remainingTime = minimumTime - elapsedTime;
			const minimumDelay = remainingTime > 0 ? remainingTime : 0;

			const timeoutId = setTimeout(() => {
				setLoading(false);
			}, minimumDelay);

			// Cleanup: Clear timeout if component unmounts
			return () => clearTimeout(timeoutId);
		}
	}, [isLoading, initialLoadTime, minimumTime]);

	return loading;
};
